import { DbConnectionConfig } from '@luzula/luzula-lib';

/**
 * Implementierung der DB-Verbindungskonfiguration.
 * Kapselt Server-URL, Credentials und Port-Konfiguration.
 */
class DbConnection implements DbConnectionConfig {
	constructor(
		private serverName: string,
		private user: string,
		private password: string,
		private protocol: 'http' | 'https' = 'https',
		private port?: number,
		public name?: string
	) {
		if (!port) this.port = protocol === 'http' ? 80 : 443;
	}

	url(db: string): string {
		const base = `${this.protocol}://${this.user}:${this.password}@${this.serverName}`;
		const srv = (this.protocol === 'http' && this.port === 80) || (this.protocol === 'https' && this.port === 443)
			? base
			: `${base}:${this.port}`;
		return `${srv}/${db}`;
	}
}

/**
 * Zentrale DB-Verbindungskonfiguration für die Anwendung.
 * Wird via DB_CONNECTION_CONFIGS InjectionToken bereitgestellt.
 */
export const dbConnectionConfigs: DbConnectionConfig[] = [
	new DbConnection('db.waldkonzepte.de', 'waldadmin', 'Eequoh)b4doo', 'https', undefined, 'Production'),
	// new DbConnection('localhost', 'waldadmin', 'Eequoh)b4doo', 'http', 5984, 'Local'),
];
